import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getVisibleSubaccounts,
  getFilters,
  getPagination,
  getIsLoading,
} from 'subaccounts/selectors';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';

import * as Subaccounts from 'subaccounts/components';
import SubaccountRowContainer from 'subaccounts/containers/SubaccountRowContainer';
import SubaccountsListHandlers from 'subaccounts/containers/SubaccountsListHandlers';
import { toggle } from 'subaccounts/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class SubaccountsListContainer extends Component {
  renderRows = () =>
    this.props.subaccounts.map((subaccount) => (
      <SubaccountRowContainer
        key={subaccount.id}
        subaccount={subaccount}
        handleToggle={this.handleToggle}
      />
    ));
  handleToggle = (id) =>
    this.props
      .toggle(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));
  render = () => (
    <SubaccountsListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <Subaccounts.ListView
          count={this.props.subaccounts.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleToggle={this.handleToggle}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.renderRows()}
        </Subaccounts.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
  subaccounts: getVisibleSubaccounts(state),
  filters: getFilters(state),
  pagination: getPagination(state),
  isLoading: getIsLoading(state),
});
const mapDispatchToProps = { toggle, error, success };

export default connect(mapStateToProps, mapDispatchToProps)(SubaccountsListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/containers/SubaccountsListContainer.js